import {API_SERVER} from 'const';

const BASE_URL = '/webclient/API/v1/wc';

export const api = {
   login: API_SERVER + BASE_URL + '/auth/login',
   changepassword: API_SERVER + BASE_URL + '/auth/changepassword',
   logout: API_SERVER + BASE_URL + '/auth/logout',
   files: API_SERVER + BASE_URL + '/files/list',
   createFolder: API_SERVER + BASE_URL + '/files/createDir',
   rename: API_SERVER + BASE_URL + '/files/rename',
   remove: API_SERVER + BASE_URL + '/files/delete',
   upload: API_SERVER + BASE_URL + '/files/upload',
   download: API_SERVER + BASE_URL + '/files/download',
};
